/**
 * Social identity providers accepted by POST /v4/authentication/{provider}
 * and login analytics. Call sites use the named members.
 */
export const SocialSignInProvider = {
  Google: "google",
  Apple: "apple",
} as const;

export type SocialSignInProvider = typeof SocialSignInProvider[keyof typeof SocialSignInProvider];
